// ============================================================
//  NETWORK CONFIG — switch here, nothing user-facing.
//  Set ACTIVE_NETWORK to 'mainnet' or 'testnet'.
// ============================================================
export const ACTIVE_NETWORK = 'testnet'; // 'mainnet' | 'testnet'

export const NETWORKS = {
  mainnet: {
    key: 'mainnet',
    chainId: 204,
    chainIdHex: '0xcc',
    name: 'opBNB',
    rpcUrls: [
      'https://opbnb-mainnet-rpc.bnbchain.org',
      'https://opbnb-rpc.publicnode.com',
      'https://opbnb.publicnode.com'
    ],
    explorer: 'https://opbnbscan.com',
    nativeCurrency: { name: 'BNB', symbol: 'BNB', decimals: 18 }
  },
  testnet: {
    key: 'testnet',
    chainId: 5611,
    chainIdHex: '0x15eb',
    name: 'opBNB',
    rpcUrls: [
      'https://opbnb-testnet-rpc.bnbchain.org',
      'https://opbnb-testnet.publicnode.com'
    ],
    explorer: 'https://opbnb-testnet.bscscan.com',
    nativeCurrency: { name: 'BNB', symbol: 'BNB', decimals: 18 }
  }
};

export const ACTIVE = NETWORKS[ACTIVE_NETWORK];
